import React, { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie"
import axios from "axios";

export const UserContext = createContext();

const url = "https://www.bitmasta.io/php/functioned.php";
export const UserProvider = (props) => {
  const [user, setUser] = useState();
  const [userDetails, setUserDetails] = useState();
  const [admin, setAdmin] = useState();
  useEffect(() => {
      const auth = Cookies.get("auth")
      const adminAuth = Cookies.get("admin--auth")
      if(auth){
       setUser(auth)
      }
      if(adminAuth){
        setAdmin(adminAuth)
      }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
        const formData = new FormData()
        formData.append("Active_User",user)
        formData.append("Details",true)
        const res = await axios.post(url, formData)
        if(res.data.details)
        setUserDetails(res.data.details[0])
    }
    fetchData()
  }, [user])
  

  return (
    <UserContext.Provider value={{ user, setUser, admin,setAdmin,userDetails }}>
      {props.children}
    </UserContext.Provider>
  );
};
